module.exports = __webpack_public_path__ + "static/media/graphtheory.26dcba42.png";